<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <svg-icon src="./assets/images/icons/close.svg"></svg-icon>
    </button>
</div>
<div class="modal-body text-center">
    <svg-icon src="./assets/images/icons/declined.svg" [svgStyle]="{'width.px':50}"
        class="d-block mb-3 mb-md-4"></svg-icon>
    <h4 class="font-weight-semibold mb-1 mb-md-2">Declined</h4>
    <p class="mb-2 mb-md-3 mb-lg-4">Notified to the Tenant Admin and Capitaland Admin</p>
    <p class="font-weight-semibold mb-1 mb-md-2">Reference No.</p>
    <p class="font-weight-semibold h3 text-primary mb-3 mb-md-4">30356894</p>
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" class="text-left">
        <div class="form-group floating_form_field mb-0 w-100">
            <textarea formControlName="reason" id="reason" class="form-control"
                placeholder="Reason for decline"></textarea>
            <label>Reason for decline</label>
        </div>
        <div class="d-flex align-items-center justify-content-end column-gap-3 mt-3 mt-md-4 mt-lg-5">
            <button class="btn btn-primary" type="submit">Submit</button>
        </div>
    </form>
</div>